// extracted by mini-css-extract-plugin
export var card = "_vj-0";
export var details = "_vj-1";